import type { Components, Theme } from '@mui/material';

const listItemButtonThemeConfig: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: {
      '&.Mui-selected': {
        // TODO: no VDS token for this value (rgba(33, 150, 243, 0.08)) — needs designer input (Barry Richardson)
        background: 'rgba(33, 150, 243, 0.08)',
      },
    },
  },
};

export const muiListItemThemeConfig = {
  MuiListItemButton: {
    ...listItemButtonThemeConfig,
  },
};
